export default "__VITE_ASSET__C8Ivl5Dm__"